import * as yup from 'yup';

const email_validation = yup
    .string()
    .email('Enter a valid email')
    .matches(/^[^+]*$/, 'We do not accept + alias email addresses')
    .required('Email is required');

const password_validation = yup
    .string()
    .min(12, 'Password should be of minimum 12 characters length')
    .matches(/[0-9]/, 'Password must contain at least one digit')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter.')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter.')
    .matches(/\W|_/, 'Password must contain at least one symbol.')
    .matches(/^\S+$/, 'Password must not contain spaces.')
    .required('Password is required');

const name_validation = yup
    .string()
    // .matches(/^[a-zA-Z]+$/, 'Only alphabetic characters')
    // .min(1, 'This field should be of minimum 1 characters length')
    // .max(25, 'This field should be of maximum 25 characters length')
    .required('This field is required');

const company_name_validations = yup.string().required('This field is required');

export const loginValidationSchema = yup.object({
    email: email_validation,
    password: password_validation,
});

// export const registrationValidationSchema = yup.object({
//     email: email_validation,
//     password: password_validation,
//     first_name: name_validation,
//     last_name: name_validation,
// });
export const createNewUserValidationSchema = yup.object({
    firstName: name_validation,
    lastName: name_validation,
    password: password_validation,
});

export const editUserInfoValidationSchema = yup.object({
    firstName: name_validation,
    lastName: name_validation,
    email: email_validation,
});

// export const resetPasswordValidationSchema = yup.object({
//     customer_email_address: email_validation,
//     customer_password: password_validation,
//     repeat_password: password_validation.oneOf([yup.ref('customer_password'), null], 'Passwords must match'),
// });

// export const changePasswordValidationSchema = yup.object({
//     password: password_validation,
//     new_password: password_validation.oneOf([yup.ref('password'), null], 'Passwords must match'),
// });
export const changePasswordValidationSchema = yup.object({
    password: password_validation,
    newPassword: password_validation,
});

export const emailValidationSchema = yup.object({
    email: email_validation,
});

export const createCompanyValidationSchema = yup.object({
    name: company_name_validations,
    firstName: yup.string(),
    lastName: yup.string(),
    email: email_validation,
});
